import type { ToastApi } from "./ToastProvider";

/**
 * Imperative bridge so non-React code (e.g. the React Query client, created
 * above `ToastProvider` in the tree) can raise toasts. `ToastProvider`
 * registers its handler on mount; calls made before it mounts are no-ops.
 */
let handler: ToastApi | null = null;

export function registerToastHandler(api: ToastApi | null) {
  handler = api;
}

export const toast: ToastApi = {
  success: (title, description, options) =>
    handler?.success(title, description, options),
  error: (title, description, options) =>
    handler?.error(title, description, options),
  info: (title, description, options) =>
    handler?.info(title, description, options),
};
